"use client";

export function ChartEmpty() {
  return (
    <div className="absolute inset-0 flex items-center justify-center">
      <p className="text-[#8f98a0] text-sm">
        No data available for the selected period.
      </p>
    </div>
  );
}

